import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '@/layout'

const routes = [
  {
    path: '/test',
    name: 'Test',
    component: () => import('@/views/test/index.vue')
  },
  {
    path: '/',
    name: 'Index',
    redirect: '/login',
    component: Layout
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/manager',
    name: 'Manager',
    component: () => import('@/views/manager/index.vue')
  },
  {
    path: '/supervise',
    name: 'Supervise',
    component: () => import('@/views/bigScreen/home/index.vue')
  },
  {
    path: '/teacherSuperviseWarn',
    name: 'TeacherSuperviseWarn',
    component: () => import('@/views/bigScreen/home/teacherSuperviseWarn.vue')
  },
  {
    path: '/evaSuperviseWarn',
    name: 'EvaSuperviseWarn',
    component: () => import('@/views/bigScreen/home/evaSuperviseWarn.vue')
  },
  {
    path: '/eduSuperviseWarn',
    name: 'EduSuperviseWarn',
    component: () => import('@/views/bigScreen/home/eduSuperviseWarn.vue')
  },
  {
    path: '/investSuperviseWarn',
    name: 'InvestSuperviseWarn',
    component: () => import('@/views/bigScreen/home/investSuperviseWarn.vue')
  },
  {
    path: '/schoolSuperviseWarn',
    name: 'SchoolSuperviseWarn',
    component: () => import('@/views/bigScreen/home/schoolSuperviseWarn.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/dashboard/index.vue')
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404')
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401')
  },
  {
    path: '/401/linkNotTime',
    component: () => import('@/views/error-page/linkNotTime')
  },
  {
    path: '/401/linkTimeout',
    component: () => import('@/views/error-page/linkTimeout')
  },
  {
    path: '/401/linkDisable',
    component: () => import('@/views/error-page/linkDisable')
  },
  // 404 page must be placed at the end !!!
  { path: '/:catchAll(.*)', redirect: '/404'}
]

const router = createRouter({
  mode:'history',
  history: createWebHashHistory(),
  routes
})

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  console.log('resetRouter')
  const newRouter = createRouter({
    history: createWebHashHistory(),
    routes: routes
  })
  router.resolve = newRouter.resolve // reset router
}

export { router }
